import PropTypes from 'prop-types';
import { STATUS_COLORS, STATUS_LABELS } from '../../utils/orderConstants';

/**
 * Small inline status pill used in the employee portal tables.
 * Styled with the order's semantic color (border + tinted background).
 *
 * @param {string} status     - Raw status key (e.g. 'confirmed')
 * @param {string} [className] - Additional CSS classes to merge in
 */
const EmpStatusPill = ({ status, className = '' }) => {
  const color = STATUS_COLORS[status] || '#9c8f7e';
  const label = STATUS_LABELS[status] || status || '—';

  return (
    <span
      className={`emp-status-pill${className ? ` ${className}` : ''}`}
      style={{
        color,
        backgroundColor: `${color}12`,
        borderColor:     `${color}35`,
      }}
    >
      {label}
    </span>
  );
};

EmpStatusPill.propTypes = {
  status:    PropTypes.string,
  className: PropTypes.string,
};

export default EmpStatusPill;
